"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = void 0;
exports.builder = {
    withValue: (value, errorMessage) => ({
        type: 'EXACT_VALUE',
        value,
        errorMessage,
    }),
    withPathAndValue: (path, value, errorMessage) => ({
        type: 'EXACT_VALUE',
        path,
        value,
        errorMessage,
    }),
};
//# sourceMappingURL=ExactValueBuilder.js.map